module.exports = __webpack_public_path__ + "static/media/ico-alert.d364b6d7.svg";